enum ROUTE_ENUM {
  SUCCESS = "success",
  ERROR = "error",
  LOADING = "loading",
}

export default ROUTE_ENUM;
